import { render, staticRenderFns } from "./d-video-info.vue?vue&type=template&id=56621f9e&lang=pug&"
import script from "./d-video-info.vue?vue&type=script&lang=js&"
export * from "./d-video-info.vue?vue&type=script&lang=js&"
import style0 from "./d-video-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56621f9e')) {
      api.createRecord('56621f9e', component.options)
    } else {
      api.reload('56621f9e', component.options)
    }
    module.hot.accept("./d-video-info.vue?vue&type=template&id=56621f9e&lang=pug&", function () {
      api.rerender('56621f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/displays/d-video-info.vue"
export default component.exports